module.exports = __webpack_public_path__ + "media/images/emblems/Lengnau_bei_Biel-coat_of_arms-81e3155e6fd0cf971836d57e2eab0d4f.svg";